import { Modal, IconButton, CircularProgress, Box } from "@mui/material";
// import MicIcon from "@mui/icons-material/Mic";
import { ReactComponent as MicIcon } from "assets/icons/Mic.svg";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { ReactComponent as UploadIcon } from "assets/icons/UploadArrowIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useEffect, useRef, useState } from "react";
import Selectinput from "features/order_client_details/components/Selectinput";
import { ReactComponent as FileIcon } from "../../../../assets/icons/update_img_icons/File_Icon.svg";
import CommentComp from "components/ui/commentInput/CommentComp";
import AudioPlayer from "components/ui/commentSection/audioPlayer/AudioPlayer";
import { getIcon } from "utils/iconsConfig";
import apiClient from "lib/api-client";

import SearchAndSelect from "features/order_client_details/components/SearchAndSelect";
import { useAllClientsinfinite } from "features/Setting/Service Request/API/getAllServiceRequest";
import { toast } from "react-toastify";
import { useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import useGatiClients from "features/order_client_details/api/useGatiClientsNamesDetails";
import { partial } from "lodash";
import Webcam from "react-webcam";

const CreateServiceRequestModal = ({ open, handleClose }) => {
  const [clientName, setClientName] = useState("");
  const [clientId, setClientId] = useState("");
  const [category, setCategory] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [designNo, setDesignNo] = useState("");
  const [concern, setConcern] = useState("");
  const [startRecording, setStartRecording] = useState(false);
  const commentRef = useRef(null);
  const fileInputRef = useRef(null);
  const singlefileInputRef = useRef(null);
  const [recordedData, setRecordedData] = useState(false);
  const [recordedBlobData, setRecordedBlobData] = useState(null);
  const [showAudioPlayer, setAudioPlayer] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dropDownLoading, setDropDownLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [options, setOptions] = useState([]);
  const [nameOfClient, setNameOfClient] = useState({ name: "", partyCode: "", clientId: "" });
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const queryClient = useQueryClient();

  // Webcam states
  const webcamRef = useRef(null);
  const [tempCapturedImage, setTempCapturedImage] = useState(null);
  const [isHoveringCaptured, setIsHoveringCaptured] = useState(false);

  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const isSelectingRef = useRef(false);

  const { data } = useGatiClients();

  const isDisabled = !nameOfClient?.clientId || !concern.trim() || !category || !serviceType || selectedFiles.length === 0 || loading;

  const handleMicClick = () => {
    setStartRecording(true);
    setTimeout(() => {
      commentRef.current?.handleMicFunction();
    }, 100);
  };

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const handleSingleFileClick = () => {
    singlefileInputRef.current?.click();
  };

  const validateForm = () => {
    const newErrors = {};
    if (!nameOfClient?.clientId) {
      newErrors.clientName = "Client name is required";
    }
    if (!concern.trim()) {
      newErrors.concern = "Concern is required";
    }
    if (!category) {
      newErrors.category = "Category is required";
    }
    if (!serviceType) {
      newErrors.serviceType = "Service type is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Webcam functions
  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return;
    setTempCapturedImage(imageSrc);
  };

  const handleAcceptImage = async () => {
    if (!tempCapturedImage) return;

    const res = await fetch(tempCapturedImage);
    const blob = await res.blob();

    const file = new File([blob], `camera-${Date.now()}.png`, {
      type: "image/png",
    });

    setSelectedFiles((prev) => [...prev, file]);
    setTempCapturedImage(null);
  };

  const handleRejectImage = () => {
    setTempCapturedImage(null);
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      setHasSubmitted(true);
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("clientId", nameOfClient.clientId);
      formData.append("concern", concern);
      formData.append("categoryName", category);
      formData.append("serviceType", serviceType);
      formData.append("designNo", designNo || "");

      selectedFiles.forEach((file) => {
        formData.append("imageUrls", file);
      });

      if (recordedBlobData instanceof File) {
        formData.append("voiceNote", recordedBlobData);
      }

      const response = await apiClient.post("/api/v9/serviceRequest/createServiceRequestForVision", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(`${"Service Request created successfully"}`, {
        autoClose: 1000,
        hideProgressBar: false,
      });

      handleClose();
      queryClient.invalidateQueries({ queryKey: ["service-requests"] });
      resetForm();
    } catch (err) {
      console.error("API ERROR:", err);
      toast.error(err?.response?.data?.message, {
        autoClose: 1000,
        hideProgressBar: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const fetchDesignSuggestions = async (value) => {
    try {
      const res = await apiClient.get(`/api/v9/serviceRequest/getAllJewelCode?search=${value}`);
      const data = res.data;

      if (data.success) {
        setSuggestions(data.data || []);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching design numbers", error);
      setSuggestions([]);
    } finally {
      setDropDownLoading(false);
    }
  };
  const debouncedFetch = useRef(debounce(fetchDesignSuggestions, 300)).current;

  const resetForm = () => {
    setNameOfClient({ name: "", partyCode: "", clientId: "" });
    setCategory("");
    setServiceType("");
    setDesignNo("");
    setConcern("");
    setSelectedFiles([]);
    setRecordedData(false);
    setRecordedBlobData(null);
    setErrors({});
    setHasSubmitted(false);
    setTempCapturedImage(null);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const imageFiles = files.filter((file) => file.type.startsWith("image/"));
    setSelectedFiles((prev) => [...prev, ...imageFiles]);

    e.target.value = "";
  };

  const removeFile = (indexToRemove) => {
    setSelectedFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  useEffect(() => {
    return () => {
      if (recordedData) URL.revokeObjectURL(recordedData);
    };
  }, [recordedData]);

  useEffect(() => {
    return () => {
      selectedFiles.forEach((file) => {
        if (file && typeof file === "object" && file.type) {
          URL.revokeObjectURL(file);
        }
      });
    };
  }, [selectedFiles]);

  useEffect(() => {
    if (data) {
      const filteredClients = data.filter((item) => item.clientName !== "(As Per Detail)");
      setOptions(filteredClients);
    }
  }, [data]);

  const handleBlur = () => {
    if (isSelectingRef.current) {
      isSelectingRef.current = false;
      return;
    }

    if (designNo) {
      if (suggestions.length === 0) {
        setDesignNo("");
      } else {
        const match = suggestions.find((item) => item.styleNumber?.toLowerCase().trim() === designNo.toLowerCase().trim());
        if (match) {
          setDesignNo(match.styleNumber);
        } else {
          setDesignNo(suggestions[0]?.styleNumber || "");
        }
      }
    }
    setShowDropdown(false);
    setSuggestions([]);
    setDropDownLoading(false);
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={handleClose}>
      <div
        style={{
          width: "1170px",
          height: "auto",
          background: "#0e0e0e",
          color: "#fff",
          borderRadius: 12,
          padding: 24,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontWeight: 500, fontFamily: "Poppins", fontSize: "22px" }}>Create Service Request</h3>
          <IconButton onClick={handleClose} style={{ color: "#aaa" }}>
            <CloseIcon />
          </IconButton>
        </div>

        <div style={{ height: 1, background: "#444444", margin: "16px 0" }} />

        <div style={{ display: "flex" }}>
          {/* Left Section */}
          <div style={{ width: "50%" }}>
            {/* Client Name */}
            <div style={{ gap: 16, marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: 16,
                  fontSize: "18px",
                  lineHeight: "22px",
                  letterSpacing: "-0.41px",
                  fontWeight: 400,
                  fontFamily: "Poppins",
                }}
              >
                Client Name
              </label>
              {errors.clientName && hasSubmitted && <span style={{ color: "#f44336", fontSize: "12px" }}>{errors.clientName}</span>}
              <div
                style={{
                  background: "#000",
                  borderRadius: "4px",
                  overflow: "hidden",
                  width: "100%",
                }}
              >
                <SearchAndSelect
                  value={
                    nameOfClient.name && nameOfClient.partyCode
                      ? (() => {
                          const match = options.find((opt) => opt.clientName === nameOfClient.name && opt.partyCode === nameOfClient.partyCode);
                          return match ? `${match.clientName} (${match.partyCode})` : null;
                        })()
                      : null
                  }
                  onchange={(selectedOption) => {
                    const selectedClient = {
                      name: selectedOption.clientName,
                      partyCode: selectedOption.partyCode,
                      clientId: selectedOption.clientId || selectedOption._id
                    };
                    setNameOfClient(selectedClient);
                  }}
                  handleSearchClear={() => {
                    setNameOfClient({ name: "", partyCode: "", clientId: "" });
                  }}
                  options={(() => {
                    const uniqueMap = new Map();
                    options.forEach((opt) => {
                      const key = `${opt.clientName}-${opt.partyCode}`;
                      if (!uniqueMap.has(key)) {
                        uniqueMap.set(key, opt);
                      }
                    });
                    const uniqueOptions = Array.from(uniqueMap.values());
                    return uniqueOptions
                      .sort((a, b) => a.clientName.localeCompare(b.clientName))
                      .map((opt) => ({
                        label: `${opt.clientName} (${opt.partyCode})`,
                        value: `${opt.clientName} (${opt.partyCode})`,
                        clientName: opt.clientName,
                        partyCode: opt.partyCode,
                        clientId: opt.clientId || opt._id,
                      }));
                  })()}
                  showSearch={true}
                  filterOption={(input, option) => {
                    if (!input) return true;
                    const searchTerm = input.toLowerCase().trim();
                    const label = option.label?.toLowerCase() || "";
                    return label.includes(searchTerm);
                  }}
                  filterSort={(optionA, optionB, inputValue) => {
                    return optionA.label.toLowerCase().indexOf(inputValue.toLowerCase()) - optionB.label.toLowerCase().indexOf(inputValue.toLowerCase());
                  }}
                  style={{
                    background: "transparent",
                    color: "#fff",
                    border: "none",
                    width: "100%",
                    height: "5.2vh",
                    padding: "10px",
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    outline: "none",
                  }}
                />
              </div>
            </div>
            {/* Concern */}
            <div style={{ gap: 16, marginBottom: "24px" }}>
              <div style={{ position: "relative", marginBottom: "16px", display: "flex", alignItems: "center" }}>
                <label style={{ display: "block", marginBottom: -3, fontFamily: "Poppins", fontSize: "18px", fontWeight: 400 }}>Concern</label>
                <IconButton
                  style={{
                    position: "absolute",
                    height: "35px",
                    width: "35px",
                    borderRadius: "50%",
                    right: 1,
                    color: "#fff",
                    background: "#444444",
                  }}
                  onClick={handleMicClick}
                >
                  <MicIcon />
                </IconButton>
              </div>
              {errors.concern && hasSubmitted && <span style={{ color: "#f44336", fontSize: "12px" }}>{errors.concern}</span>}
              <div style={{ position: "relative", marginTop: 20 }}>
                <textarea
                  rows={5}
                  placeholder="Enter Your Message"
                  value={concern}
                  onChange={(e) => {
                    setConcern(e.target.value);
                    if (errors.concern) setErrors((prev) => ({ ...prev, concern: "" }));
                  }}
                  style={{
                    width: "100%",
                    background: "#000",
                    color: "#fff",
                    border: "0.5px solid #ffffffff",
                    borderRadius: 8,
                    padding: 10,
                    resize: "none",
                    outline: "none",
                    fontSize: "16px",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                  }}
                />
                {startRecording && (
                  <CommentComp
                    ref={commentRef}
                    isFileUpload={false}
                    setStartRecording={setStartRecording}
                    setRecordedData={setRecordedData}
                    setRecordedBlobData={setRecordedBlobData}
                    setAudioPlayer={setAudioPlayer}
                    mode="audio"
                  />
                )}
                {showAudioPlayer && <AudioPlayer src={recordedData} />}
              </div>
            </div>

            {/* Category + Design */}
            <div style={{ display: "flex", gap: 16, marginBottom: "24px" }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: "block", marginBottom: 12, fontFamily: "Poppins", fontSize: "18px", fontWeight: 400 }}>Category</label>
                <Selectinput
                  options={[
                    "Bali",
                    "Bands",
                    "Bangles",
                    "Brooches",
                    "Buttons",
                    "Charms",
                    "Cuff Links",
                    "Earrings",
                    "Gents Bracelets",
                    "Gents Chains",
                    "Gents Pendants",
                    "Gents Rings",
                    "Gold Belts",
                    "Gold Gents Bracelet",
                    "Gold Gents Watches",
                    "Gold Ladies Bracelets",
                    "Gold Ladies Watches",
                    "Ladies Bracelets",
                    "Ladies Chains",
                    "Ladies Pendants",
                    "Ladies Rings",
                    "Mangalsutra",
                    "Necklace",
                    "Nose Pin",
                    "Other",
                    "Pens",
                    "Steel Belts",
                    "Steel Frame",
                    "Steel Mobile",
                    "Steel Watches",
                  ]}
                  value={category}
                  onchange={(e) => {
                    setCategory(e.target.value);
                    if (errors.category) setErrors((prev) => ({ ...prev, category: "" }));
                  }}
                  placeHolder={"Choose Category"}
                  customStyle={{
                    width: "100%",
                    height: "5.28vh",
                    background: "#000",
                    color: "#fff",
                    borderRadius: "4px",
                  }}
                />
                {errors.category && hasSubmitted && <span style={{ color: "#f44336", fontSize: "12px" }}>{errors.category}</span>}
              </div>

              <div style={{ flex: 1, position: "relative" }}>
                {showDropdown &&
                  (dropDownLoading ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #444",
                        padding: 8,
                        color: "#000",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <CircularProgress size={16} />
                      <span>Loading Styles...</span>
                    </div>
                  ) : suggestions.length === 0 ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #444",
                        padding: 8,
                        color: "#000",
                        zIndex: 10,
                      }}
                    >
                      Design Not found.
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        color: "#000",
                        border: "1px solid #fff",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 10,
                        cursor: "pointer",
                      }}
                    >
                      {suggestions.map((item, index) => (
                        <div
                          key={index}
                          style={{ padding: "8px", cursor: "pointer" }}
                          onMouseDown={() => {
                            isSelectingRef.current = true;
                            setDesignNo(item.styleNumber);
                            setShowDropdown(false);
                            setSuggestions([]);
                          }}
                        >
                          {item.styleNumber}
                        </div>
                      ))}
                    </div>
                  ))}

                <label
                  style={{
                    display: "block",
                    marginBottom: 12,
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: 400,
                  }}
                >
                  Design No.
                  <span
                    style={{
                      color: "#777",
                      fontSize: 12,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                    }}
                  >
                    (Optional)
                  </span>
                </label>

                <div
                  style={{
                    width: "100%",
                    background: "#000",
                    color: "#fff",
                    border: "0.5px solid #fff",
                    borderRadius: 4,
                    padding: 10,
                    height: "5.28vh",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    ref={inputRef}
                    onBlur={handleBlur}
                    placeholder="Enter Design No."
                    value={designNo}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDesignNo(value);

                      if (value.length > 1) {
                        setShowDropdown(true);
                        setDropDownLoading(true);
                        setSuggestions([]);
                        debouncedFetch(value);
                      } else {
                        setSuggestions([]);
                        setShowDropdown(false);
                      }
                    }}
                    style={{
                      outline: "none",
                      border: "none",
                      height: "100%",
                      width: "100%",
                      background: "transparent",
                      color: "white",
                      fontFamily: designNo ? "Karla" : "Poppins",
                      fontSize: "0.8vw",
                      fontWeight: 500,
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Service Type */}
            <div>
              <label style={{ display: "block", marginBottom: "24px", fontFamily: "Poppins", fontSize: "18px", fontWeight: 400 }}>Service Request Type</label>
              <Selectinput
                options={["Manufacturing Defects", "QC Failed", "Repairing Request"]}
                value={serviceType}
                onchange={(e) => {
                  setServiceType(e.target.value);
                  if (errors.serviceType) setErrors((prev) => ({ ...prev, serviceType: "" }));
                }}
                placeHolder={"Choose Type"}
                customStyle={{
                  width: "100%",
                  height: "5.28vh",
                  background: "#000",
                  color: "#fff",
                  borderRadius: "4px",
                }}
              />
              {errors.serviceType && hasSubmitted && <span style={{ color: "#f44336", fontSize: "12px" }}>{errors.serviceType}</span>}
            </div>
          </div>

          {/* Upload Box */}
          <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>
            {selectedFiles.length === 0 && !tempCapturedImage ? (
              <div
                style={{
                  width: "525px",
                  height: "516px",
                  border: "1px solid #777",
                  borderRadius: 10,
                  position: "relative",
                  overflow: "hidden",
                  background: "#000",
                }}
              >
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/png"
                  videoConstraints={{
                    facingMode: "environment",
                  }}
                  onUserMediaError={(err) => {
                    if (err.name === "NotAllowedError") {
                      alert("Permission denied");
                    } else if (err.name === "NotFoundError") {
                      alert("No camera device")
                    }
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    background: "#000",
                  }}
                />

                {/* Capture Button */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 20,
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  <button
                    onClick={handleCapture}
                    style={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      border: "4px solid white",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Upload Icon Top Right */}
                <IconButton
                  onClick={handleFileClick}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    color: "#fff",
                    zIndex: 10,
                  }}
                >
                  <UploadIcon />
                </IconButton>

                <input type="file" ref={fileInputRef} multiple accept=".jpg,.jpeg,.png" style={{ display: "none" }} onChange={handleFileChange} />
              </div>
            ) : tempCapturedImage ? (
              <div
                style={{
                  width: "525px",
                  height: "516px",
                  border: "1px solid #777",
                  borderRadius: 10,
                  position: "relative",
                  overflow: "hidden",
                  background: "#000",
                }}
                onMouseEnter={() => setIsHoveringCaptured(true)}
                onMouseLeave={() => setIsHoveringCaptured(false)}
              >
                <img
                  src={tempCapturedImage}
                  alt="Preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />

                {/* Hover Upload Overlay - Only show when there are uploaded files */}
                {isHoveringCaptured && selectedFiles.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(0, 0, 0, 0.7)",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 15,
                      transition: "all 0.3s ease",
                    }}
                    onClick={handleSingleFileClick}
                  >
                    <p
                      style={{
                        color: "#fff",
                        fontSize: 14,
                        fontWeight: 500,
                        fontFamily: "Poppins",
                      }}
                    >
                      {getIcon("UploadIcon", "white")}
                    </p>
                    <p
                      style={{
                        color: "#FFFFFF",
                        fontSize: 24,
                        marginTop: 0,
                        fontFamily: "Karla",
                      }}
                    >
                      Upload
                    </p>
                  </div>
                )}

                <div
                  sx={{
                    position: "relative",
                    width: 350,
                    borderRadius: "12px",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      width: "100%",
                      height: 70,
                      background: "#191818BF", // 👈 GREY like your image
                      backdropFilter: "blur(6px)", // 👈 smooth glass effect
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    {/* ❌ Reject */}
                    <IconButton
                      onClick={handleRejectImage}
                      sx={{
                        color: "white",
                        "&:hover": {
                          background: "#191818BF",
                        },
                      }}
                    >
                      <CloseIcon fontSize="large" />
                    </IconButton>

                    {/* ✔ Accept */}
                    <IconButton
                      onClick={handleAcceptImage}
                      sx={{
                        color: "white",
                        "&:hover": {
                          background: "rgba(255,255,255,0.1)",
                        },
                      }}
                    >
                      <CheckIcon fontSize="large" />
                    </IconButton>
                  </Box>
                </div>

                <input type="file" ref={singlefileInputRef} multiple accept=".jpg,.jpeg,.png" style={{ display: "none" }} onChange={handleFileChange} />
              </div>
            ) : (
              <div
                style={{
                  height: "516px",
                  width: "525px",
                  border: "1px solid #777676ff",
                  borderRadius: 10,
                  display: "flex",
                  flexDirection: "column",
                  overflowY: "auto",
                  cursor: "pointer",
                }}
              >
                {selectedFiles.map((item, index) => {
                  const previewSrc = URL.createObjectURL(item);

                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "1px solid #444",
                        borderRadius: 8,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        flexShrink: 0,
                        position: "relative",
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      onClick={handleFileClick}
                    >
                      {/* Remove Button */}
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          removeFile(index);
                        }}
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          background: "rgba(0, 0, 0, 0.7)",
                          color: "#fff",
                          zIndex: 999,
                          padding: "4px",
                        }}
                        size="small"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>

                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0, 0, 0, 0.7)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 15,
                            transition: "all 0.3s ease",
                          }}
                          onClick={handleSingleFileClick}
                        >
                          <p
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              fontWeight: 500,
                              fontFamily: "Poppins",
                            }}
                          >
                            {getIcon("UploadIcon", "white")}
                          </p>
                          <p
                            style={{
                              color: "#FFFFFF",
                              fontSize: 24,
                              marginTop: 0,
                              fontFamily: "Karla",
                            }}
                          >
                            Upload
                          </p>
                        </div>
                      )}

                      {/* Image Preview - Full Box */}
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "#000",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={previewSrc}
                          alt="preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <input type="file" ref={singlefileInputRef} multiple accept=".jpg,.jpeg,.png" style={{ display: "none" }} onChange={handleFileChange} />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ marginTop: 32, display: "flex", justifyContent: "center" }}>
          <button
            onClick={handleSubmit}
            disabled={isDisabled || loading}
            style={{
              background: isDisabled ? "#555555" : "#26df54ff",
              border: "none",
              padding: "12px 40px",
              borderRadius: 8,
              cursor: isDisabled ? "not-allowed" : "pointer",
              height: "50px",
              fontSize: "18px",
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "#000000",
              display: "flex",
              alignItems: "center",
            }}
          >
            {loading ? (
              <>
                <CircularProgress size={20} style={{ color: "#fff", marginRight: 8 }} />
                <span>Creating...</span>
              </>
            ) : (
              <span>Create</span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateServiceRequestModal;
